module.exports = __webpack_public_path__ + "img/18.f2ca39a1.jpg";